import { InputText } from '@unbooking/ui-kit';
import { FC, useEffect } from 'react';
import { IRequestTrainingFormStepProps, RequestTrainingStep } from '../common/interfaces';
import BaseStep from './components/BaseStep';
import InputWarning from './components/InputWarning';
import { nonEmptyValidation } from '../common/FieldValidationWarning';
import { RequiredUnderline } from '@/components/common';

const STEP = RequestTrainingStep.ATTENDEES;

export const AttendeesStep: FC<IRequestTrainingFormStepProps> = ({
  formData,
  updateFormData,
  goToNextStep,
  goToPreviousStep,
  updateStepCompleted,
}) => {
  const formStep = formData[STEP];

  const numOfAttendeesValidator = nonEmptyValidation(formStep.num_of_attendees);
  const nextStepEnabled = [numOfAttendeesValidator].every(validator => validator === null);

  useEffect(() => {
    updateStepCompleted(STEP, nextStepEnabled);
  }, [nextStepEnabled]);

  return (
    <BaseStep
      goToNextStep={goToNextStep}
      formStep={STEP}
      goToPreviousStep={goToPreviousStep}
      nextStepEnabled={nextStepEnabled}
    >
      <div className="flex flex-col w-full gap-10">
        <div className="flex flex-col items-stretch">
          <div className="text-white mb-2">Number of participants</div>
          <InputText
            value={formStep.num_of_attendees}
            onChange={e => updateFormData('num_of_attendees', e.target.value)}
            name="num-of-attendees"
            placeholder="..."
          />
          {formStep.num_of_attendees ? (
            <div className="mt-2">
              <InputWarning
                text={
                  'Please note that additional details about each participant will be necessary at a later stage to confirm the training request (Name, Last Name, Driver Licence etc...).'
                }
              />
            </div>
          ) : null}
          {numOfAttendeesValidator && <RequiredUnderline />}
          {/* <FieldValidationWarning result={numOfAttendeesValidator} /> */}
        </div>
      </div>
    </BaseStep>
  );
};

export default AttendeesStep;
